
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  //重定向操作
  {path:'/home',redirect:'/'},
  {path:'/',component: () => import('../views/Home.vue')},
  {
      path: '/h5-task',
      name: 'H5Task',
      component: () => import('@/views/H5Embed.vue'),
      meta: { title: '任务中心', icon: 'el-icon-s-order', keepAlive: true }
  },
  {path:'/category',component: () => import('../views/Category.vue')},
  {path:'/categorySearch',component: () => import('../views/CategorySearch.vue')},
  {path:'/terminalMode',component: () => import('../views/terminalMode.vue')},
  {path:'/rcbh',component: () => import('../views/rcbh.vue')},
  {path:'/qhbh',component: () => import('../views/qhbh.vue')},
  {path:'/rwc',component: () => import('../views/rwc.vue')},
  {path:'/agysbh',component: () => import('../views/agysbh.vue')},
  {path:'/catlist',component: () => import('../views/Catlist.vue')},
  {path:'/productview',component: () => import('../views/productview.vue')},
  {path:'/largeViewImge',component: () => import('../views/largeViewImge.vue')},
  {path:'/news',component: () => import('../views/News.vue'),
    children:[
      // {path:'/',redirect:'/show'},
      // {path:'/show',component: () => import('../components/Show.vue')}
    ]
  },
  {path:'/NewsView',component: () => import('../views/NewsView.vue')},
  {path:'/cart',component: () => import('../views/Cart.vue')},
  {path:'/bj_cart',component: () => import('../views/bj_cart.vue')},
  {path:'/bj_history',component: () => import('../views/bj_history.vue')},
  {path:'/ks_bj',component: () => import('../views/ks_bj.vue')},
  {path:'/ls_history',component: () => import('../views/ls_history.vue')},
  {path:'/rwl',component: () => import('../views/rwl.vue')},
  {path:'/settle',component: () => import('../views/Settlement.vue')},
  {path:'/completion',component: () => import('../views/Completion.vue')},
  {path:'/paytype',component: () => import('../views/Paytype.vue')},
  {path:'/CompletionAccount',component: () => import('../views/CompletionAccount.vue')},
  {path:'/PaytypeForOrder',component: () => import('../views/PaytypeForOrder.vue')},
  {path:'/WechatPay',component: () => import('../views/WechatPay.vue')},
  {path:'/CompletionForYuFu',component: () => import('../views/CompletionForYuFu.vue')},
  {path:'/CompletionForHll',component: () => import('../views/CompletionForHll.vue')},
  {path:'/forHll',component: () => import('../views/forHll.vue')},
  {
    path:'/yuFuPay',
    component: () => import('../views/yuFuPay.vue')
  },
  {path:'/customNonStandard',component: () => import('../views/customNonStandard.vue')},
  {path:'/quickOrder',component: () => import('../views/QuickOrder.vue')},
  {path:'/jmbwh_info',component: () => import('../views/mine/jmbwh_info.vue')},
  {path:'/jmbwh_list_info',component: () => import('../views/mine/jmbwh_list_info.vue')},
  {
    path:'/Mine',
    component: () => import('../views/Mine.vue'),
    children:[
      {path:'/',redirect:'/membercenter'},
      {path:'/membercenter',component: () => import('../views/mine/MemberCenter.vue')},
      {path:'/xslrbb',component: () => import('../views/mine/xslrbb.vue')},
      {path:'/xsdd',component: () => import('../views/mine/xsdd.vue')},
	  {path:'/cwfh',component: () => import('../views/mine/cwfh.vue')},
      {path:'/cwsh',component: () => import('../views/mine/cwsh.vue')},
      {path:'/wkds',component: () => import('../views/mine/wkds.vue')},
      {path:'/wkfh',component: () => import('../views/mine/wkfh.vue')},
      {path:'/ddfh',component: () => import('../views/mine/ddfh.vue')},
      {path:'/ddtk',component: () => import('../views/mine/ddtk.vue')},
      {path:'/refundPend',component: () => import('../views/mine/refundPend.vue')},
      {path:'/order',component: () => import('../views/mine/Order.vue')},
      {path:'/notice',component: () => import('../views/mine/Notice.vue')},
      {path:'/record',component: () => import('../views/mine/Record.vue')},
      {path:'/invoicing',component: () => import('../views/mine/Invoicing.vue')},
      {path:'/station',component: () => import('../views/mine/Station.vue')},
      {path:'/personal',component: () => import('../views/mine/Personal.vue')},
      {path:'/modify',component: () => import('../views/mine/Modify.vue')},
      {path:'/address',component: () => import('../views/mine/Address.vue')},
      {path:'/children',component: () => import('../views/mine/Children.vue')},
      {path:'/relation',component: () => import('../views/mine/Relation.vue')},
      {path:'/orderdetail',component: () => import('../views/mine/OrderDetail.vue')},
      {path:'/returndetail',component: () => import('../views/mine/ReturnDetail.vue')},
      {path:'/apply',component: () => import('../views/mine/Apply.vue')},
      {path:'/account',component: () => import('../views/mine/AccountList.vue')},
      {path:'/accountdetail',component: () => import('../views/mine/AccountDetail.vue')},
      {path:'/advance',component: () => import('../views/mine/Advance.vue'),
        meta: {
          title: '预付款充值',
          keepAlive: false
        }
      },
      {path:'/customList',component: () => import('../views/mine/customList.vue')},
      {path:'/customdetail',component: () => import('../views/mine/customdetail.vue')},
      {path:'/Complaint',component: () => import('../views/mine/Complaint.vue')},
      {path:'/ComplaintDetail',component: () => import('../views/mine/ComplaintDetail.vue')},
      //日常管理
      {path:'/gysgl',component: () => import('../views/mine/gysgl.vue')},
      {path:'/downCenter',component: () => import('../views/mine/downCenter.vue')},
      //档案管理
      {path:'/gyslb',component: () => import('../views/mine/gyslb.vue')},
      {path:'/qyfs',component: () => import('../views/mine/qyfs.vue')},
      {path:'/slda',component: () => import('../views/mine/slda.vue')},
      {path:'/jyjb',component: () => import('../views/mine/jyjb.vue')},
      {path:'/zthz',component: () => import('../views/mine/zthz.vue')},
      {path:'/workOrder',component: () => import('../views/mine/workOrder.vue')},
      {path:'/jmbwh',component: () => import('../views/mine/jmbwh.vue'),
        meta: {
          title: '供应商价目表',
          keepAlive: true
        }
      },
      {path:'/jmbwh_list',component: () => import('../views/mine/jmbwh_list.vue')},
    ]
  },
  //   ]
  // },
  
  {
    path: '/login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/modify',
    component: () => import('../components/logins/modify.vue')
  },
  {
    path: '/register',
    component: () => import('../components/logins/register.vue')
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
